import React, { CSSProperties, MouseEventHandler } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import { Spinner } from "../../../Styles";
import { CoreStoreInstance } from "../../../../Stores";
//EN: Have to use explicit path directly to avoid an error.
//eg: We cant use "Core/Components"

export interface MainButtonProps {
    /**
     * Show please wait and a spinner
     */
    isLoading?: boolean;
    className?: string;
    style?: CSSProperties;
    buttonText: string;
    showChevron?: boolean;
    onClick?: () => void;
    color?: "primary" | "secondary" | string;
    showDivider?: boolean;
}
export const MainButton: React.FC<MainButtonProps> = (props: MainButtonProps) => {
    let mainColor: string = props.color as string;
    if (mainColor === "primary" || mainColor === "secondary") {
        mainColor = CoreStoreInstance.Theme.palette[mainColor].main as string;
    }

    return (
        <>
            {props.showDivider && <Box marginBottom={"50px"} marginTop={"50px"} borderTop={`1px solid ${mainColor}`} />}
            <Box textAlign={"center"} marginBottom={"50px"}>
                <Button
                    style={{ height: "50px", backgroundColor: mainColor, ...props.style }}
                    className={props.className}
                    disabled={props.isLoading}
                    onClick={props.onClick}
                    /*color={"primary"}*/
                    type="submit"
                    variant={"contained"}
                >
                    <Typography component={"div"} style={{ color: "white" }}>
                        {props.isLoading ? (
                            <Box display={"flex"} flexDirection={"rows"} alignItems={"center"}>
                                <Spinner />
                                <Typography component={"div"}>Please wait...</Typography>
                            </Box>
                        ) : (
                            <>
                                {props.buttonText} {props.showChevron && <span>&#187;</span>}
                            </>
                        )}
                    </Typography>
                </Button>
            </Box>
        </>
    );
};
MainButton.defaultProps = {
    isLoading: false,
    color: "primary",
};
